import { gql } from '@apollo/client'

const GET_EXTRACT = gql`
  query GetExtract($documentHash: ID!, $includeFutureEvents: Boolean, $nextPage: String) {
    getExtract(documentHash: $documentHash, includeFutureEvents: $includeFutureEvents, nextPage: $nextPage) {
      currentMovements {
        movementId
        event
        eventDate
        amountPoint
        amountValue
        accumulatedPoint
        accumulatedValue
        movementType
        availableFrom
        operationType
        businessUnit
        origin {
          channel
          originId
          identifier
        }
        payment {
          total
        }
        expirationDate
        createdAt
        tier
      }
      futureMovements {
        createdAt
        movementId
        eventDate
        amountPoint
        amountValue
        movementType
        availableFrom
        operationType
        payment {
          total
        }
      }
      nextPage
    }
  }
`

export default GET_EXTRACT
